import { render, staticRenderFns } from "./ProductEditorWeb.vue?vue&type=template&id=61694f0a&scoped=true&"
import script from "./ProductEditorWeb.vue?vue&type=script&lang=js&"
export * from "./ProductEditorWeb.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditorWeb.vue?vue&type=style&index=0&id=61694f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61694f0a",
  null
  
)

export default component.exports